<script>
    import FButtonSection from "@/components/FButtonSection";

    export default {
        name: "FPageFinances",
        components: { FButtonSection }
    };
</script>

<template>
    <section>
        <FButtonSection
            href="https://clienteseguro.multipluscard.com.br/jmvtef"
            icon="credit_card"
            title="Conciliador TEF"
            descr="Controle de operações do cartão TEF"
        />
    </section>
</template>